var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAccept(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      transform: "translateY(2px)"
    },
    id: "icon-accept",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.258,
    height: 22.188,
    viewBox: "0 0 21.258 22.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M66.287,98.637h-3.88a.65.65,0,1,0,0,1.3h3.88a.65.65,0,1,0,0-1.3Zm0,0",
    transform: "translate(-59.081 -94.362)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M66.287,158.641h-3.88a.65.65,0,1,0,0,1.3h3.88a.65.65,0,1,0,0-1.3Zm0,0",
    transform: "translate(-59.081 -151.766)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M66.287,218.645h-3.88a.65.65,0,1,0,0,1.3h3.88a.65.65,0,1,0,0-1.3Zm0,0",
    transform: "translate(-59.081 -209.169)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M66.287,278.648h-3.88a.65.65,0,0,0,0,1.3h3.88a.65.65,0,0,0,0-1.3Zm0,0",
    transform: "translate(-59.081 -266.573)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M66.287,339.656h-3.88a.65.65,0,1,0,0,1.3h3.88a.65.65,0,1,0,0-1.3Zm0,0",
    transform: "translate(-59.081 -324.937)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M202.306,99.937h3.88a.65.65,0,1,0,0-1.3h-3.88a.65.65,0,0,0,0,1.3Zm0,0",
    transform: "translate(-192.917 -94.362)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M202.306,159.941h3.88a.65.65,0,1,0,0-1.3h-3.88a.65.65,0,0,0,0,1.3Zm0,0",
    transform: "translate(-192.917 -151.766)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M204.825,219.295a.65.65,0,0,0-.65-.65h-1.869a.65.65,0,0,0,0,1.3h1.869A.65.65,0,0,0,204.825,219.295Zm0,0",
    transform: "translate(-192.917 -209.169)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M314.088,342.831a.65.65,0,0,0-.914.1l-1.674,2.087-1.037-.751a.65.65,0,1,0-.763,1.053l1.538,1.114a.649.649,0,0,0,.888-.12l2.062-2.57A.65.65,0,0,0,314.088,342.831Zm0,0",
    transform: "translate(-296.023 -327.837)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M19.708,13a5.361,5.361,0,0,0-3.114-1.565V2.618A2.621,2.621,0,0,0,13.977,0H2.618A2.621,2.621,0,0,0,0,2.618V17.676a2.621,2.621,0,0,0,2.618,2.618h9.136a5.351,5.351,0,0,0,4.105,1.894A5.4,5.4,0,0,0,19.708,13ZM1.3,17.676V2.618A1.32,1.32,0,0,1,2.618,1.3H13.977a1.319,1.319,0,0,1,1.318,1.318v8.795a5.406,5.406,0,0,0-4.364,7.581H2.618A1.319,1.319,0,0,1,1.3,17.676Zm14.559,3.212a4.1,4.1,0,0,1,0-8.2h.074a4.1,4.1,0,0,1-.074,8.2Zm0,0",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccept);
export default __webpack_public_path__ + "static/media/icon-accept.7b45ed85.svg";
export { ForwardRef as ReactComponent };